<template>
  <div class="page">
    <span style="color: crimson">Внимание! Большая часть функционала перенесена в manager.vezdevoz.ru</span>
  </div>
</template>
